"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  return (0, _core.jsx)("path", {
    d: "M247.9 41.2c-115.1 0-208.3 93.3-208.3 208.3s93.3 208.3 208.3 208.3c115.1 0 208.3-93.3 208.3-208.3S363 41.2 247.9 41.2zM81.3 249.5c0-38.5 13.1-74 35-102.2l233.9 233.9c-28.2 21.9-63.7 35-102.2 35-92.1 0-166.7-74.7-166.7-166.7zm298.3 102.2L145.7 117.8c28.2-21.9 63.7-35 102.2-35 92 0 166.7 74.6 166.7 166.7 0 38.5-13.1 74-35 102.2z"
  });
};

exports.default = _default;